import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";

import {  OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../../components/SkeltonTable/skeletonTable";
import { useDispatch, useSelector } from "react-redux";
import { getUserByPropIdApi } from "../../../../service/property/getUserByPropId";
import { findSubMenuByName } from "../../propertyList/MenuUtlis";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, Grid } from "@mui/material";
import ExpiryDateFilter from "../../propertyList/ExpiryDateFilter";

export const VendorTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDeleteById,
  handleTabExpanded,
  userArr,
  handleActionMultipleApprove,
  handleSeeVendor,
  handleEditVendor,
  setPageSizeViewVendor,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  setFilterType
}) => {
  const {permissionArr} = useSelector(state =>state.auth)
  const {permissions} = useSelector(state =>state.permissionsData)

  const dispatch = useDispatch()
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const userData = useMemo(() => userArr, [userArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const tableInstance = useTable({ columns, data }, useSortBy);
useEffect(()=>{},[userArr])
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //footerGroups,
    rows,
    prepareRow,
  } = tableInstance;
 
 
 


  
  // Helper function to check if a specific action exists in a submenu
  const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);

  // Find the "Properties" menu
  const propertiesMenu = findSubMenuByName(permissions, 'Vendor');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'Vendor List') : null;

  // Check actions in the "Approved" submenu
  const canApprove = listPropertyMenu ? hasAction(listPropertyMenu, 'Approve') : false;
  const canSearch = listPropertyMenu ? hasAction(listPropertyMenu, 'Search') : false;
  const canMoreFilter = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'MoreFilters') : false;
  const canAudittrial = listPropertyMenu ? hasAction(listPropertyMenu, 'Audittrial') : false;
  const canActive = listPropertyMenu ? hasAction(listPropertyMenu, 'Active') : false;
  const canAddVendor = listPropertyMenu ? hasAction(listPropertyMenu, 'AddVendor') : false;
  const canAssignUsers = listPropertyMenu ? hasAction(listPropertyMenu, 'AssignUsers') : false;
  const canViewUsers = listPropertyMenu ? hasAction(listPropertyMenu, 'ViewUsers') : false;
  const canViewVendors = listPropertyMenu ? hasAction(listPropertyMenu, 'ViewVendors') : false;
  const MoreFilterSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'MoreFilters') : null;
  const invoiceType = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'InvoiceType') : false;
  const expiryDate = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'ExpiryDate') : false;

  const handlePageSizeChange=(event)=>{
    setPageSizeViewVendor(event.target.value)
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const [type, setTpe] = React.useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
    const handleChange = (event) => {
      setTpe(event.target.value);
    };
  
    useEffect(() => {
      setFilterType(type)
    }, [type])
    
      // Masking Function
      const maskValueGSTIN = (value, visibleStart, visibleEnd, maskChar = "*") => {
        if (!value || typeof value !== "string") return "";
        const totalLength = value.length;
        const maskedLength = totalLength - (visibleStart + visibleEnd);
    
        if (maskedLength <= 0) return value;
    
        const maskedPart = maskChar.repeat(maskedLength);
        return (
          value.slice(0, visibleStart) +
          maskedPart +
          value.slice(totalLength - visibleEnd)
        );
      };  const maskValuePAN = (value, visibleStart, visibleEnd, maskChar = "*") => {
        if (!value || typeof value !== "string") return "";
        const totalLength = value.length;
        const maskedLength = totalLength - (visibleStart + visibleEnd);
    
        if (maskedLength <= 0) return value;
    
        const maskedPart = maskChar.repeat(maskedLength);
        return (
          value.slice(0, visibleStart) +
          maskedPart +
          value.slice(totalLength - visibleEnd)
        );
      };

    
  return (
    <>

      <div className="card">
        <div className="card-header">
        <div className="d-flex justify-content-end" style={{width:'100%'}}>
        {canSearch&&(
            <div className="service-input-group input-group" style={{width:"220px"}}>
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                    </div>
                            )}

                            {canMoreFilter && (

                              <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform:'none'
        }}
      >
        More Filters<span class="material-icons">
arrow_drop_down
</span>
      </Button>
        )}
      <ExpiryDateFilter
 onLoadData={()=>{
  onLoadData("InvoiceList",type)
  handleClose()
}}
 open={open}
 fromDate={fromDate}
 toDate={toDate}
 setFromDate={setFromDate}
 anchorEl={anchorEl}
 handleClose={handleClose}
 setToDate={setToDate}
 type={type}
 handleChange={handleChange}
 isVendorList={true}
 showInvoiceType={invoiceType}
 showExpDate={expiryDate}
 setTpe={setTpe}
 />
            </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display" >
             {!showLoading && <>
              <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" ,width:'0px',padding:"10px 5px"}}
                        >
                          {column.render("Header")}
                          <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
             
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    return (

                      <>
                       <tr {...row.getRowProps()} style={{padding:'5px 0px',margin:0}}>
                        {row.cells.map((cell, cellIndex) => {
                      const isLastColumn = cellIndex === row.cells.length - 1;
                      const { BankDetails } = row.original;
                      const hasBankDetails = BankDetails !== null;
                      const isBankVerified = hasBankDetails && BankDetails.isBankVerified;
                      // const isVendorNameColumn = cell.column.id === 'VendorName';
                      const isVendorNameColumn = cellIndex === 0;

                      // {console.log(cell.render("Cell") )}

                          return (

                            
                          
                            
                            <td
                              {...cell.getCellProps()}
                              style={{ color: "black" ,whiteSpace:'normal', padding:'5px 5px',margin:0 }}
                            >
                              {
                                isLastColumn ? (
                                
                                <div>
{canActive&&
 <OverlayTrigger
 placement="top"
 overlay={
   <Tooltip id="tooltip">{"Active"}</Tooltip>
 }
>
 <i
   className="material-icons"
   style={{
     color: "orange",
     marginRight: "6px",
     cursor: "pointer",
   }}
   onClick={() => {
     handleEditVendor(
       
       rows[rowIndex].original
     );
   }}
 >
   edit
 </i>
</OverlayTrigger>
}
                                </div>
                              
                              ):(<div>
                                          {isVendorNameColumn ?(
                                    <div style={{ display: 'flex'}}>
                                      {rows[rowIndex].original.IsBankVerified!==false ? (
                                        <>
                                         <Grid container spacing={0}>
                                          <Grid item xs={1}>
                                          <OverlayTrigger
 placement="top"
 overlay={
   <Tooltip id="tooltip">{"Bank details are verified"}</Tooltip>
 }
>
                                          <CheckCircleIcon style={{ color: 'green', marginRight: '8px' }} />
</OverlayTrigger>
                                          </Grid>
                                          <Grid item xs={11}>
{/* <div style={{marginLeft:'15px'}}>
{(isVendorNameColumn &&rows[rowIndex].original.VendorName)}
</div> */}
<div style={{ marginLeft: '15px', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} 
     title={rows[rowIndex].original.VendorName}>
  {isVendorNameColumn && rows[rowIndex].original.VendorName}
</div>
                                          </Grid>
                                          </Grid>
                                          </>
                                        ) : (
                                          <>
                                                                                   <Grid container spacing={0}>
                                                                                   <Grid item xs={1}>
                                                                                   <OverlayTrigger
 placement="top"
 overlay={
   <Tooltip id="tooltip">{"Bank details are not verified"}</Tooltip>
 }
>
                                          <CancelIcon style={{ color: 'red', marginRight: '8px' }} />
                                          </OverlayTrigger>
                                          </Grid>
                                          <Grid item xs={11}>
{/* <div style={{marginLeft:'15px'}}>
{(isVendorNameColumn &&rows[rowIndex].original.VendorName)}
</div> */}
<div style={{ marginLeft: '15px', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} 
     title={rows[rowIndex].original.VendorName}>
  {isVendorNameColumn && rows[rowIndex].original.VendorName}
</div>
                                          </Grid>
                                          </Grid>
                                          </>
                                        )}
                                    </div>):null}{
                                      (cell.column.id === "VendorName" && (
                                        <div style={{display:'none'}}>
    {cell.value}
  </div>                              ))||
(cell.column.id === "VendorEmail" && (
  <div>
    {cell.value .split(/[,/]/).map((email, index) => (
      <div key={index}>{email}</div>
    ))}
  </div>
)) ||                                                                    //  cellIndex === 2
                                                                    //   ? maskValueGSTIN(cell.value, 2, 3)
                                                                    //   : cellIndex === 4
                                                                    //   ? maskValuePAN(cell.value, 2, 2)
                                                                    //   :
                                                                       cell.render("Cell")
                        
                                }
                                  </div>)
                              }
                         
                         
                       
                           
                            </td>
                          );
                        })}

                      </tr>
                    
                      </>
                     

                      
                      
                    );
                  })}
                </tbody></>}
             {showLoading &&   <SkeletonTableRow cols={4} row ={4}/>}
                {/* This is only for footer if u require */}
              </table>

              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}

            </div>
          </div>
                            {/* Pagination & Page Size */}
        <div className="pagination-container d-flex justify-content-between">
          <div style={{marginTop:"20px"}}>
            <label htmlFor="pageSizeSelect">Rows per page: </label>
            <select
              id="pageSizeSelect"
              value={pageSizePagination}
              onChange={handlePageSizeChange}
              style={{ marginLeft: "10px" }}
            >
                 <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
            </select>
          </div>
<PaginationAndSearching
                  handleSearch={handleSearchPagination}
                  searchValue={searchValuePagination}
                  defaultValue={pageSizePagination}
                  handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                  totalCount={totalCountPagination}
                  onChange={(e,p)=>{
                    handleOnChangePagination(e,p)
                    // setCheckedRows([])
                  }}
                />
             </div>
        </div>
      </div>
    </>
  );
};
export default VendorTable;
